import React from 'react';
import { usePromotionalsHook } from 'src/promotionals/usePromotionalsHook';
import { BulkDiscount, FreeDelivery } from 'src/shared/design-system/BulkDiscount';
import { useBulkDiscount } from 'src/shared/hooks/useBulkDiscount';
import { useIsDishFirst } from '../../../../../dish-first/useIsDishFirst';
import { usePromoReducer } from '../store';
import { Promo } from '../styles';
import { BulkDiscountContainer, FreeDeliveryContainer } from './styles';
import { PromoContentType } from './types';

export const BulkDiscountPromoContent: React.FC<PromoContentType> = (props) => {
  const { isContentShowing, showInline } = props;
  const { collapse, expand, isExpanded, isShowing, setSpacer } = usePromoReducer();
  const { code } = usePromotionalsHook();
  const freeDeliveryFromPromo = code?.isFreeDelivery;
  const { isDishFirst } = useIsDishFirst();

  const {
    bulkDiscountTiers,
    deliveryFee,
    hasBulkDiscounts,
    hasItemsInCart,
    hasZipCode,
    isBulkDiscountExperiment,
    minimumAmountForDiscountedShipping,
    promoApplied,
    subtotal,
    discountedDeliveryFee,
  } = useBulkDiscount();

  const sharedProps = {
    deliveryFee: deliveryFee ?? 0,
    discountedDeliveryFee: discountedDeliveryFee ?? 0,
    discountedDeliveryThreshold: minimumAmountForDiscountedShipping ?? 0,
    hasItemsInCart,
    promoValue: promoApplied,
    total: hasItemsInCart ? subtotal : 0,
    showFreeDelivery:
      !freeDeliveryFromPromo && (!deliveryFee || !discountedDeliveryFee || deliveryFee !== discountedDeliveryFee),
  };

  const hasDiscountContent = (isBulkDiscountExperiment && hasBulkDiscounts) || sharedProps.showFreeDelivery;
  const hideRow = !showInline && (!hasZipCode || !isShowing || isContentShowing || !hasDiscountContent);

  // Shef lite markets do upfront delivery pricing, so we cant do bulk discounts in their current form (where the first tier offers free delivery)
  // We could explore changing the tier to be a % off.
  if (!isDishFirst) {
    return null;
  }

  return hideRow ? null : (
    <Promo.Row id='BulkUpsellBanner' hide={hideRow}>
      <Promo.Container>
        {isBulkDiscountExperiment && hasBulkDiscounts ? (
          <BulkDiscountContainer>
            <BulkDiscount
              isExpanded={isExpanded}
              handleCollapse={collapse}
              handleExpand={expand}
              tiers={bulkDiscountTiers}
              hasFreeDeliveryPromo={freeDeliveryFromPromo}
              {...sharedProps}
            />
          </BulkDiscountContainer>
        ) : (
          sharedProps.showFreeDelivery && (
            <FreeDeliveryContainer>
              <FreeDelivery {...sharedProps} />
              <>{!showInline && setSpacer(<Promo.Spacer hide={!isShowing} />)}</>
            </FreeDeliveryContainer>
          )
        )}
      </Promo.Container>
    </Promo.Row>
  );
};
